export default {
  common: {
    MOP: 'Pide y Retira',
  },
  checkout: {
    checkoutAlert:
      'En las compras por la web, por el momento, sólo se emite boleta electrónica generalizada.',
  },
}
